import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import './App.css';
import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import usePageTracking from './hooks/usePageTracking';

// Lazy loaded pages (reduces initial bundle — not used for blog pages since
// react-snap needs them eagerly loaded to pre-render content for AI crawlers)
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfUse = lazy(() => import('./pages/TermsOfUse'));
const Support = lazy(() => import('./pages/Support'));
const KotoKotoPrivacyPolicy = lazy(() => import('./pages/KotoKotoPrivacyPolicy'));
const KotoKotoSupport = lazy(() => import('./pages/KotoKotoSupport'));
const LearnLesson = lazy(() => import('./pages/LearnLesson'));
const Invite = lazy(() => import('./pages/Invite'));
const Press = lazy(() => import('./pages/Press'));

function AppContent() {
  usePageTracking();

  return (
    <div className="app-shell">
      <Navbar />
      <main className="app-main">
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/support" element={<Support />} />
            <Route path="/press" element={<Press />} />
            <Route path="/learn/:id" element={<LearnLesson />} />
            <Route path="/invite/:id" element={<Invite />} />
            <Route path="/koto-koto/privacy-policy" element={<KotoKotoPrivacyPolicy />} />
            <Route path="/koto-koto/support" element={<KotoKotoSupport />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
